import withURLSearchParamsHandler from "../../../../../../components/hoc/withURLSearchParamsHandler";
import ReportHistory from "./ReportHistory";

const ReportHistoryWithURLSearchParamsHandler = withURLSearchParamsHandler(ReportHistory);
export default ReportHistoryWithURLSearchParamsHandler;